import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import Avatar from "./basic-20-avatar.png";
import BgOption1 from "../images/bg-option-1.png";
import BgOption2 from "../images/bg-option-2.png";
import BgOption3 from "../images/bg-option-3.png";

import TemplateImage from "./template-image.png";
import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic20 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #20";
    this.id = "20";
    this.url = "/ai/carousels/basic-20";
    this.description = "Create a carousel of images";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Justin Jackson",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@mijustin",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#36BFFA",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },

        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#FFFFFF",
        },
        {
          label: "Secondry Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#000000",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Inter",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Podcasts are one of the best ways to generate many different types of content.
                
If you film an episode, there are a bunch of ways you can repurpose it.

This flywheel generates content whenever you’re interviewed on someone’s podcast:`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: "",
          },
          {
            label: "Time",
            target_key: "description",
            type: "text",
            value: `1:45 PM · Jun 16, 2023`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "500",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: ``,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
          {
            label: "Time",
            target_key: "description",
            type: "text",
            value: `1:45 PM · Jun 16, 2023`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "primary_font",
              },

              fontWeight: {
                value: "500",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `What if the point of going on a podcast wasn’t the podcast itself?
                
What if going on podcasts was a significant part of your content creation strategy?

By simply showing up to speak, you can produce blog posts, newsletters, and social media content.`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: "",
          },
          {
            label: "Time",
            target_key: "description",
            type: "text",
            value: `1:45 PM · Jun 16, 2023`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "500",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Here’s how it works:
                
You accept an interview request with the understanding that you’ll be provided with the video recording afterward and allowed to repurpose the content however you see fit. Meaning you can clip it, transcribe it, turn it into blog posts, graphics, etc.`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: "",
          },
          {
            label: "Time",
            target_key: "description",
            type: "text",
            value: `1:45 PM · Jun 16, 2023`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "primary_font",
              },

              fontWeight: {
                value: "500",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Sub CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "If you got this far and found this post valuable:",
            max_words: 3,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "Follow me",
            max_words: 3,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "20px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getSecondaryColor(common_settings) {
    return common_settings.elements[5].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getSecondaryColorVariant(common_settings) {
    return this.getSecondaryColor(common_settings) + "50";
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[6]?.value || "Inter";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div
          className="relative w-[352px] h-[452px] p-[24px] rounded-xl flex flex-col gap-[24px] items-center justify-center"
          style={{
            backgroundColor: this.getPrimaryColor(commonSettings),
          }}
        >
          <div className="flex flex-col items-center gap-[12px]">
            <img
              className="object-cover w-[80px] h-[80px] rounded-full"
              src={
                commonSettings.elements[1].value.image
                  ? commonSettings.elements[1].value.image
                  : LogoPlaceholder
              }
              style={{
                backgroundColor: this.getPrimaryColor(commonSettings),
              }}
              alt=""
            />
            <div className="flex flex-col items-center">
              <div className="flex items-center gap-1">
                <p
                  className="text-[18px] leading-[28px] font-semibold "
                  style={{ color: this.getSecondaryColor(commonSettings) }}
                >
                  {commonSettings.elements[0].value}
                </p>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_2475_241)">
                    <path
                      d="M10.0083 1.67584C10.6565 1.67588 11.2824 1.91198 11.7692 2.34001L11.8975 2.46084L12.4792 3.04251C12.6388 3.2011 12.8473 3.30122 13.0708 3.32668L13.1833 3.33334H14.0167C14.6977 3.3333 15.3529 3.59382 15.848 4.06146C16.343 4.5291 16.6404 5.16843 16.6792 5.84834L16.6833 6.00001V6.83334C16.6833 7.05834 16.76 7.27751 16.8983 7.45251L16.9733 7.53584L17.5542 8.11751C18.0356 8.59622 18.3163 9.24053 18.3391 9.91907C18.3618 10.5976 18.1249 11.2593 17.6767 11.7692L17.5558 11.8975L16.9742 12.4792C16.8156 12.6388 16.7155 12.8473 16.69 13.0708L16.6833 13.1833V14.0167C16.6834 14.6977 16.4229 15.3529 15.9552 15.848C15.4876 16.3431 14.8482 16.6404 14.1683 16.6792L14.0167 16.6833H13.1833C12.9586 16.6834 12.7405 16.7592 12.5642 16.8983L12.4808 16.9733L11.8992 17.5542C11.4205 18.0356 10.7761 18.3163 10.0976 18.3391C9.41907 18.3619 8.75739 18.1249 8.2475 17.6767L8.11916 17.5558L7.5375 16.9742C7.37786 16.8156 7.16941 16.7155 6.94583 16.69L6.83333 16.6833H6C5.31898 16.6834 4.66376 16.4229 4.16869 15.9552C3.67362 15.4876 3.37623 14.8483 3.3375 14.1683L3.33333 14.0167V13.1833C3.33326 12.9587 3.25752 12.7406 3.11833 12.5642L3.04333 12.4808L2.4625 11.8992C1.98107 11.4205 1.70035 10.7762 1.67759 10.0976C1.65482 9.41908 1.89173 8.7574 2.34 8.24751L2.46083 8.11918L3.0425 7.53751C3.20109 7.37788 3.30121 7.16942 3.32666 6.94584L3.33333 6.83334V6.00001L3.3375 5.84834C3.37471 5.19455 3.65119 4.5773 4.11424 4.11425C4.57729 3.6512 5.19454 3.37472 5.84833 3.33751L6 3.33334H6.83333C7.05801 3.33327 7.27612 3.25753 7.4525 3.11834L7.53583 3.04334L8.1175 2.46251C8.36528 2.21325 8.65989 2.01543 8.98439 1.88043C9.30888 1.74542 9.65687 1.67589 10.0083 1.67584ZM13.0892 7.74418C12.9329 7.58795 12.721 7.50019 12.5 7.50019C12.279 7.50019 12.0671 7.58795 11.9108 7.74418L9.16666 10.4875L8.08916 9.41084L8.01083 9.34168C7.84334 9.21217 7.63283 9.15127 7.42206 9.17134C7.21129 9.19142 7.01607 9.29097 6.87604 9.44978C6.73601 9.60858 6.66168 9.81473 6.66814 10.0264C6.6746 10.238 6.76137 10.4392 6.91083 10.5892L8.5775 12.2558L8.65583 12.325C8.81617 12.4494 9.01638 12.511 9.2189 12.4983C9.42142 12.4855 9.61234 12.3993 9.75583 12.2558L13.0892 8.92251L13.1583 8.84418C13.2827 8.68384 13.3443 8.48363 13.3316 8.28111C13.3188 8.07859 13.2326 7.88767 13.0892 7.74418Z"
                      fill="#0BA5EC"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2475_241">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <p
                className="text-[16x] leading-[24px] font-medium opacity-60"
                style={{ color: this.getSecondaryColor(commonSettings) }}
              >
                {commonSettings.elements[2].value}
              </p>
            </div>
          </div>

          <div className="flex flex-col justify-between items-center gap-4 font-semibold">
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}

            <div
              className="w-fit px-6 py-3 rounded-lg text-[20px] leading-[30px] flex items-center justify-center"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
                color: this.getPrimaryColor(commonSettings),
              }}
            >
              {slide.elements[1]?.style ? (
                <MultilineView
                  element={slide.elements[1]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[1]?.value} />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        className="relative w-[352px] h-[452px] p-[24px] rounded-xl flex flex-col gap-[28px]"
        style={{
          backgroundColor: this.getPrimaryColor(commonSettings),
        }}
      >
        <div className="flex justify-between gap-[24px] items-center">
          <div className="flex items-center gap-3">
            <img
              className="object-cover w-[40px] h-[40px] rounded-full"
              src={
                commonSettings.elements[1].value.image
                  ? commonSettings.elements[1].value.image
                  : LogoPlaceholder
              }
              style={{
                backgroundColor: this.getPrimaryColor(commonSettings),
              }}
              alt=""
            />
            <div className="flex flex-col">
              <div className="flex items-center gap-1">
                <p
                  className="text-[16px] leading-[24px] font-semibold "
                  style={{ color: this.getSecondaryColor(commonSettings) }}
                >
                  {commonSettings.elements[0].value}
                </p>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_2475_241)">
                    <path
                      d="M10.0083 1.67584C10.6565 1.67588 11.2824 1.91198 11.7692 2.34001L11.8975 2.46084L12.4792 3.04251C12.6388 3.2011 12.8473 3.30122 13.0708 3.32668L13.1833 3.33334H14.0167C14.6977 3.3333 15.3529 3.59382 15.848 4.06146C16.343 4.5291 16.6404 5.16843 16.6792 5.84834L16.6833 6.00001V6.83334C16.6833 7.05834 16.76 7.27751 16.8983 7.45251L16.9733 7.53584L17.5542 8.11751C18.0356 8.59622 18.3163 9.24053 18.3391 9.91907C18.3618 10.5976 18.1249 11.2593 17.6767 11.7692L17.5558 11.8975L16.9742 12.4792C16.8156 12.6388 16.7155 12.8473 16.69 13.0708L16.6833 13.1833V14.0167C16.6834 14.6977 16.4229 15.3529 15.9552 15.848C15.4876 16.3431 14.8482 16.6404 14.1683 16.6792L14.0167 16.6833H13.1833C12.9586 16.6834 12.7405 16.7592 12.5642 16.8983L12.4808 16.9733L11.8992 17.5542C11.4205 18.0356 10.7761 18.3163 10.0976 18.3391C9.41907 18.3619 8.75739 18.1249 8.2475 17.6767L8.11916 17.5558L7.5375 16.9742C7.37786 16.8156 7.16941 16.7155 6.94583 16.69L6.83333 16.6833H6C5.31898 16.6834 4.66376 16.4229 4.16869 15.9552C3.67362 15.4876 3.37623 14.8483 3.3375 14.1683L3.33333 14.0167V13.1833C3.33326 12.9587 3.25752 12.7406 3.11833 12.5642L3.04333 12.4808L2.4625 11.8992C1.98107 11.4205 1.70035 10.7762 1.67759 10.0976C1.65482 9.41908 1.89173 8.7574 2.34 8.24751L2.46083 8.11918L3.0425 7.53751C3.20109 7.37788 3.30121 7.16942 3.32666 6.94584L3.33333 6.83334V6.00001L3.3375 5.84834C3.37471 5.19455 3.65119 4.5773 4.11424 4.11425C4.57729 3.6512 5.19454 3.37472 5.84833 3.33751L6 3.33334H6.83333C7.05801 3.33327 7.27612 3.25753 7.4525 3.11834L7.53583 3.04334L8.1175 2.46251C8.36528 2.21325 8.65989 2.01543 8.98439 1.88043C9.30888 1.74542 9.65687 1.67589 10.0083 1.67584ZM13.0892 7.74418C12.9329 7.58795 12.721 7.50019 12.5 7.50019C12.279 7.50019 12.0671 7.58795 11.9108 7.74418L9.16666 10.4875L8.08916 9.41084L8.01083 9.34168C7.84334 9.21217 7.63283 9.15127 7.42206 9.17134C7.21129 9.19142 7.01607 9.29097 6.87604 9.44978C6.73601 9.60858 6.66168 9.81473 6.66814 10.0264C6.6746 10.238 6.76137 10.4392 6.91083 10.5892L8.5775 12.2558L8.65583 12.325C8.81617 12.4494 9.01638 12.511 9.2189 12.4983C9.42142 12.4855 9.61234 12.3993 9.75583 12.2558L13.0892 8.92251L13.1583 8.84418C13.2827 8.68384 13.3443 8.48363 13.3316 8.28111C13.3188 8.07859 13.2326 7.88767 13.0892 7.74418Z"
                      fill="#0BA5EC"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2475_241">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <p
                className="text-[14x] leading-[20px] font-medium"
                style={{
                  color: this.getSecondaryColor(commonSettings),
                  opacity: 0.5,
                }}
              >
                {commonSettings.elements[2].value}
              </p>
            </div>
          </div>
          <svg
            width="24"
            height="20"
            viewBox="0 0 24 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_2435_555)">
              <path
                d="M0.944745 7.08657C1.6275 7.46598 2.38957 7.6783 3.16919 7.70631C2.13132 7.00085 1.39758 5.92654 1.11542 4.69935C0.833262 3.47216 1.02362 2.18307 1.64825 1.09124C2.88807 2.62004 4.43221 3.87126 6.18148 4.76454C7.93075 5.65781 9.8465 6.17341 11.8057 6.2782C11.8057 6.08285 11.7454 5.90771 11.7253 5.72583C11.5833 4.51419 11.893 3.29264 12.5947 2.29726C13.2964 1.30189 14.3402 0.603389 15.5243 0.336773C16.3465 0.127291 17.2094 0.141677 18.0242 0.378453C18.8391 0.61523 19.5765 1.06586 20.1608 1.68404C20.174 1.70283 20.1928 1.71689 20.2145 1.72416C20.2362 1.73143 20.2597 1.73153 20.2814 1.72445C21.3271 1.51759 22.3321 1.13984 23.2563 0.606227L23.33 0.56581C23.155 1.12856 22.8778 1.65387 22.5126 2.11516C22.1464 2.57759 21.7046 2.97396 21.206 3.28728C22.1652 3.17286 23.1022 2.91634 23.9866 2.52608C23.8325 2.7349 23.6851 2.94373 23.531 3.14582C22.9712 3.8604 22.3149 4.49297 21.5813 5.02525C21.566 5.03709 21.5537 5.05245 21.5456 5.07003C21.5374 5.08761 21.5336 5.10691 21.5343 5.12629C21.5645 5.78703 21.5444 6.44913 21.4741 7.10677C21.3525 8.31497 21.0732 9.50179 20.6432 10.6366C20.1547 11.9648 19.4777 13.215 18.6332 14.3483C17.9356 15.2831 17.1228 16.1251 16.2144 16.8542C14.6296 18.127 12.7751 19.0166 10.794 19.4544C10.1553 19.5937 9.5086 19.6926 8.85764 19.7508C8.09265 19.8081 7.32446 19.8081 6.55947 19.7508C4.24517 19.5977 2.00602 18.8635 0.0469048 17.6154L-0.0200806 17.5683C2.56877 17.8785 5.17511 17.1526 7.23619 15.5474C6.21184 15.5167 5.22195 15.1685 4.40201 14.5504C3.58782 13.935 2.98381 13.0805 2.67338 12.1051C3.40074 12.2449 4.1503 12.215 4.86433 12.0175C3.74991 11.773 2.7522 11.1526 2.03686 10.2594C1.31386 9.36333 0.927293 8.24023 0.944745 7.08657Z"
                fill="#0BA5EC"
              />
            </g>
            <defs>
              <clipPath id="clip0_2435_555">
                <rect
                  width="24"
                  height="19.6364"
                  fill="white"
                  transform="translate(0 0.181824)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>

        <div className="h-full flex flex-col justify-between">
          <div className="flex flex-col gap-5">
            {slide.elements[0]?.value && (
              <>
                {slide.elements[0]?.style ? (
                  <MultilineView
                    element={slide.elements[0]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[0]?.value} />
                )}
              </>
            )}
            {slide.elements[1]?.value && (
              <img
                className="w-[303px] h-[193px] object-cover"
                src={slide.elements[1].value || TemplateImage}
                alt=""
              />
            )}
          </div>

          <div className="opacity-60">
            {slide.elements[2]?.style ? (
              <MultilineView
                element={slide.elements[2]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[2]?.value} />
            )}
          </div>
        </div>
      </div>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div
          className="relative w-[352px] h-[452px] p-[24px] rounded-xl flex flex-col gap-[28px]"
          style={{
            backgroundColor: this.getPrimaryColor(commonSettings),
          }}
        >
          <div className="flex justify-between gap-[24px] items-center">
            <div className="flex items-center gap-3">
              <img
                className="object-cover w-[40px] h-[40px] rounded-full"
                src={
                  commonSettings.elements[1].value.image
                    ? commonSettings.elements[1].value.image
                    : LogoPlaceholder
                }
                style={{
                  backgroundColor: this.getPrimaryColor(commonSettings),
                }}
                alt=""
              />
              <div className="flex flex-col">
                <div className="flex items-center gap-1">
                  <p
                    className="text-[16px] leading-[24px] font-semibold "
                    style={{ color: this.getSecondaryColor(commonSettings) }}
                  >
                    {commonSettings.elements[0].value}
                  </p>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_2475_241)">
                      <path
                        d="M10.0083 1.67584C10.6565 1.67588 11.2824 1.91198 11.7692 2.34001L11.8975 2.46084L12.4792 3.04251C12.6388 3.2011 12.8473 3.30122 13.0708 3.32668L13.1833 3.33334H14.0167C14.6977 3.3333 15.3529 3.59382 15.848 4.06146C16.343 4.5291 16.6404 5.16843 16.6792 5.84834L16.6833 6.00001V6.83334C16.6833 7.05834 16.76 7.27751 16.8983 7.45251L16.9733 7.53584L17.5542 8.11751C18.0356 8.59622 18.3163 9.24053 18.3391 9.91907C18.3618 10.5976 18.1249 11.2593 17.6767 11.7692L17.5558 11.8975L16.9742 12.4792C16.8156 12.6388 16.7155 12.8473 16.69 13.0708L16.6833 13.1833V14.0167C16.6834 14.6977 16.4229 15.3529 15.9552 15.848C15.4876 16.3431 14.8482 16.6404 14.1683 16.6792L14.0167 16.6833H13.1833C12.9586 16.6834 12.7405 16.7592 12.5642 16.8983L12.4808 16.9733L11.8992 17.5542C11.4205 18.0356 10.7761 18.3163 10.0976 18.3391C9.41907 18.3619 8.75739 18.1249 8.2475 17.6767L8.11916 17.5558L7.5375 16.9742C7.37786 16.8156 7.16941 16.7155 6.94583 16.69L6.83333 16.6833H6C5.31898 16.6834 4.66376 16.4229 4.16869 15.9552C3.67362 15.4876 3.37623 14.8483 3.3375 14.1683L3.33333 14.0167V13.1833C3.33326 12.9587 3.25752 12.7406 3.11833 12.5642L3.04333 12.4808L2.4625 11.8992C1.98107 11.4205 1.70035 10.7762 1.67759 10.0976C1.65482 9.41908 1.89173 8.7574 2.34 8.24751L2.46083 8.11918L3.0425 7.53751C3.20109 7.37788 3.30121 7.16942 3.32666 6.94584L3.33333 6.83334V6.00001L3.3375 5.84834C3.37471 5.19455 3.65119 4.5773 4.11424 4.11425C4.57729 3.6512 5.19454 3.37472 5.84833 3.33751L6 3.33334H6.83333C7.05801 3.33327 7.27612 3.25753 7.4525 3.11834L7.53583 3.04334L8.1175 2.46251C8.36528 2.21325 8.65989 2.01543 8.98439 1.88043C9.30888 1.74542 9.65687 1.67589 10.0083 1.67584ZM13.0892 7.74418C12.9329 7.58795 12.721 7.50019 12.5 7.50019C12.279 7.50019 12.0671 7.58795 11.9108 7.74418L9.16666 10.4875L8.08916 9.41084L8.01083 9.34168C7.84334 9.21217 7.63283 9.15127 7.42206 9.17134C7.21129 9.19142 7.01607 9.29097 6.87604 9.44978C6.73601 9.60858 6.66168 9.81473 6.66814 10.0264C6.6746 10.238 6.76137 10.4392 6.91083 10.5892L8.5775 12.2558L8.65583 12.325C8.81617 12.4494 9.01638 12.511 9.2189 12.4983C9.42142 12.4855 9.61234 12.3993 9.75583 12.2558L13.0892 8.92251L13.1583 8.84418C13.2827 8.68384 13.3443 8.48363 13.3316 8.28111C13.3188 8.07859 13.2326 7.88767 13.0892 7.74418Z"
                        fill="#0BA5EC"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2475_241">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>

                <p
                  className="text-[14x] leading-[20px] font-medium"
                  style={{
                    color: this.getSecondaryColor(commonSettings),
                    opacity: 0.5,
                  }}
                >
                  {commonSettings.elements[2].value}
                </p>
              </div>
            </div>
            <svg
              width="24"
              height="20"
              viewBox="0 0 24 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_2435_555)">
                <path
                  d="M0.944745 7.08657C1.6275 7.46598 2.38957 7.6783 3.16919 7.70631C2.13132 7.00085 1.39758 5.92654 1.11542 4.69935C0.833262 3.47216 1.02362 2.18307 1.64825 1.09124C2.88807 2.62004 4.43221 3.87126 6.18148 4.76454C7.93075 5.65781 9.8465 6.17341 11.8057 6.2782C11.8057 6.08285 11.7454 5.90771 11.7253 5.72583C11.5833 4.51419 11.893 3.29264 12.5947 2.29726C13.2964 1.30189 14.3402 0.603389 15.5243 0.336773C16.3465 0.127291 17.2094 0.141677 18.0242 0.378453C18.8391 0.61523 19.5765 1.06586 20.1608 1.68404C20.174 1.70283 20.1928 1.71689 20.2145 1.72416C20.2362 1.73143 20.2597 1.73153 20.2814 1.72445C21.3271 1.51759 22.3321 1.13984 23.2563 0.606227L23.33 0.56581C23.155 1.12856 22.8778 1.65387 22.5126 2.11516C22.1464 2.57759 21.7046 2.97396 21.206 3.28728C22.1652 3.17286 23.1022 2.91634 23.9866 2.52608C23.8325 2.7349 23.6851 2.94373 23.531 3.14582C22.9712 3.8604 22.3149 4.49297 21.5813 5.02525C21.566 5.03709 21.5537 5.05245 21.5456 5.07003C21.5374 5.08761 21.5336 5.10691 21.5343 5.12629C21.5645 5.78703 21.5444 6.44913 21.4741 7.10677C21.3525 8.31497 21.0732 9.50179 20.6432 10.6366C20.1547 11.9648 19.4777 13.215 18.6332 14.3483C17.9356 15.2831 17.1228 16.1251 16.2144 16.8542C14.6296 18.127 12.7751 19.0166 10.794 19.4544C10.1553 19.5937 9.5086 19.6926 8.85764 19.7508C8.09265 19.8081 7.32446 19.8081 6.55947 19.7508C4.24517 19.5977 2.00602 18.8635 0.0469048 17.6154L-0.0200806 17.5683C2.56877 17.8785 5.17511 17.1526 7.23619 15.5474C6.21184 15.5167 5.22195 15.1685 4.40201 14.5504C3.58782 13.935 2.98381 13.0805 2.67338 12.1051C3.40074 12.2449 4.1503 12.215 4.86433 12.0175C3.74991 11.773 2.7522 11.1526 2.03686 10.2594C1.31386 9.36333 0.927293 8.24023 0.944745 7.08657Z"
                  fill="#0BA5EC"
                />
              </g>
              <defs>
                <clipPath id="clip0_2435_555">
                  <rect
                    width="24"
                    height="19.6364"
                    fill="white"
                    transform="translate(0 0.181824)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>

          <div className="h-full flex flex-col justify-between">
            <div className="flex flex-col gap-5">
              {slide.elements[0]?.value && (
                <>
                  {slide.elements[0]?.style ? (
                    <MultilineView
                      element={slide.elements[0]}
                      getPropertyByStyleKey={(styleKey) =>
                        this.getPropertyByStyleKey(styleKey, commonSettings)
                      }
                      getValueByKey={(key) =>
                        this.getValueByKey(key, commonSettings)
                      }
                    />
                  ) : (
                    <TextView text={slide.elements[0]?.value} />
                  )}
                </>
              )}

              {slide.elements[1]?.value && (
                <img
                  className="w-[303px] h-[193px] object-cover"
                  src={slide.elements[1].value || TemplateImage}
                  alt=""
                />
              )}
            </div>

            <div className="opacity-60">
              {slide.elements[2]?.style ? (
                <MultilineView
                  element={slide.elements[2]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[2]?.value} />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col items-center justify-center w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getPrimaryFont(commonSettings),
        }}
      >
        <div className="absolute inset-0">
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
            ></div>
          )}
        </div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
      </div>
    );
  }
}

export default Basic20;
